<script setup>
import {onLaunch, onPageNotFound} from "@dcloudio/uni-app";

onLaunch(() => {
  // #ifdef MP-WEIXIN
  // #endif
})

onPageNotFound(() => {
  console.log('页面不存在')
})

</script>

<style lang="scss">
@import "vk-uview-ui/index.scss";
/*每个页面公共css */


page {

	image {
		width: 100%;
		height: 100%;
	}

	.button_none {
		button::after {
			border: none;
		}

		button::after {
			border: 0;
		}
		// 禁用时样式
		button[disabled] {
			background-color: rgba(0, 0, 0, 0.0);
			color: #666;
		}

		button {
			position: relative;
			display: block;
			margin-left: auto;
			margin-right: auto;
			padding-left: 0px;
			padding-right: 0px;
			box-sizing: border-box;
			// font-size: 18px;
			text-align: center;
			text-decoration: none;
			// line-height: 1;
			line-height: 1.35;
			// border-radius: 5px;
			-webkit-tap-highlight-color: transparent;
			overflow: hidden;
			color: #000000;
			background-color: rgba(0, 0, 0, 0.0);;
			width: 100%;
			height: 100%;
		}
	}
}

.float_left {
	float: left;
}

.clearfloat {
	clear: both;
}

</style>
